export function imageAspectForPlatform(platform) {
  return platform === "instagram" ? undefined : "wide";
}

export function hasNonInstagramPlatform(platforms = []) {
  return (platforms || []).some((platform) => platform && platform !== "instagram");
}

export function imageAspectForPlatforms(platforms = []) {
  return hasNonInstagramPlatform(platforms) ? "wide" : undefined;
}

export function shouldAttachCoverToAsset(asset) {
  return asset?.platform && asset.platform !== "instagram";
}
